export { LegalModal } from './LegalModal';
